import { Component, Input } from '@angular/core'
import { concat, forkJoin, from, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { PortalSettingsService } from '../../../core/services/portal-settings.service'
import { UtilityService } from '../../../core/services/utility.service'
import { SmService } from '../../../pages/sm/services/sm.service'
import { SmDataService } from '../../../pages/sm/services/sm-data.service';

@Component({
  selector: 'app-new-work-order-modal',
  templateUrl: './new-work-order-modal.component.html',
  styleUrls: ['./new-work-order-modal.component.css']
})
export class NewWorkOrderModalComponent {
  @Input() technicianList: any
  formData: { [key: string]: any };
  portalSettings: any
  SMRequireSiteOnNewWO: boolean
  AllowManualWorkOrderNumber: boolean
  SMServiceSiteSuperLookup: boolean
  workOrderInvallid: boolean = false
  divisionList: any
  currentSMCo: any
  xhr: any
  lookupList: {}
  customerList: any
  customerListBack: any
  siteList: any
  centerList: any
  openModalLeft: string
  alert: string | null
  workOrderInvalid: boolean
  siteListInput$ = new Subject<any>();
  siteList$: Observable<any>;
  constructor(private ngbActiveModal: NgbActiveModal, private smService: SmService, private portalSettingsService: PortalSettingsService, public utilityService: UtilityService, public smDataService: SmDataService) {
    this.portalSettings = this.portalSettingsService.getPortalSettings()
  }

  ngOnInit() {
    this.SMRequireSiteOnNewWO = this.portalSettings.SMRequireSiteOnNewWO.ConfigValue == "1"
    this.AllowManualWorkOrderNumber = this.portalSettings.AllowManualWorkOrderNumber.ConfigValue == "1"
    this.SMServiceSiteSuperLookup = this.portalSettings.SMServiceSiteSuperLookup.ConfigValue == "1"
    this.formData = {};
    this.centerList = [];
    this.divisionList = [];
    this.lookupList = [];
    
    var count = 0;
    this.technicianList.forEach(tech => {
      if (tech.IsLoggedInUser && count == 0) {
        this.formData.technician = tech
        this.currentSMCo = this.formData.technician.SMCo
        this.getCustomers()
        this.getCenters()
        if (!this.SMServiceSiteSuperLookup) {
          this.getSite()
        }
        this.getCommonLookup()
        count++;
      }
    })

    this.registerObservables();
  }

  registerObservables() {
    this.siteList$ = concat(this.siteListInput$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(async (term: any) => {
        if (term != null && term.length > 2) {
          let result: any = await this.smService.getSitesByCustomer("sMCustomerID=" + this.formData.customer + "&includeInactive=false&searchString=" + encodeURIComponent(term));
          return result;
        }
      })
    ));
  }

  getCommonLookup() {
    this.smService.getCommonLookups("?sMCo=" + this.currentSMCo).then((response: any) => {
      this.lookupList = {}
      response.forEach((val) => {
        if (!this.lookupList.hasOwnProperty(val.LookupType))
          this.lookupList[val.LookupType] = []
        if (!isNaN(val.Code) && val.LookupType != "SMPayType" && val.LookupType == "SMCallType" && val.LookupType == "SMLaborCode" && val.LookupType != "SMServiceableItem")
          val.Code = parseInt(val.Code)
        if (val.LookupType == "SMPayType" || val.LookupType == "SMCallType" || val.LookupType == "SMLaborCode" || val.LookupType == "SMServiceableItem") {
          val.Code = val.Code.toString()
        }
        this.lookupList[val.LookupType].push(val)
      })

    });
  };

  searchFilter(term: string, item: any) {
    term = term.toLowerCase();
    return item.Technician.toLowerCase().indexOf(term) > -1 || item.Technician.toString().indexOf(term) > -1 ||
      item.UserFullName.toLowerCase().indexOf(term) > -1 || item.UserFullName.toString().indexOf(term) > -1;
  }

  technicianChanged() {
    if (this.currentSMCo != this.formData.technician.SMCo) {
      this.formData.customer = null
      this.formData.serviceCenter = null
      this.formData.serviceSite = null
      this.formData.siteContact = null
      this.formData.siteContactPhone = null
      this.currentSMCo = this.formData.technician.SMCo
      this.getCustomers()
      this.getCenters()
      if (!this.SMServiceSiteSuperLookup)
        this.getSite()
      else
        this.formData.selectedSiteName = null
      this.getCommonLookup()
    }
  }

  getCustomers() {
    this.smService.getCustomers(this.formData.technician.SMCo).then((response: any) => {
      this.customerList = response;
      this.customerListBack = response.slice();
      this.customerList.forEach((val) => {
        val.newName = val.Customer + " - " + val.CustomerName
      });
    })
  }

  public nameCheck(event) {
    this.customerList = [];
    this.customerListBack.forEach((val) => {
      if ((val.Customer != null ? val.Customer.toString().toLowerCase().indexOf(event.term.toLowerCase()) > -1 : false) ||
        (val.CustomerName != null ? val.CustomerName.toLowerCase().indexOf(event.term.toLowerCase()) > -1 : false))
        this.customerList.push(val);
    });
    return this.customerList
  }

  public resetLookup() {
    this.customerList = this.customerListBack.slice();
  }

  checkNumber() {
    this.workOrderInvalid = false
    if (isNaN(this.formData.workOrder)) {
      this.workOrderInvalid = true
    }
  }

  customerChanged() {
    this.formData.serviceSite = null
    this.formData.siteContact = null
    this.formData.siteContactPhone = null
    if (!this.SMServiceSiteSuperLookup)
      this.getSite()
    else {
      this.formData.selectedSiteName = null
    }
  }

  getSite() {
    this.smService.getSitesByCustomer("sMCustomerID=" + this.formData.customer + "&includeInactive=false").then((response: any) => {
      this.siteList = response
    })
  }

  siteChanged() {
    if (this.formData.serviceSite != null) {
      if (!this.SMServiceSiteSuperLookup) {
        this.formData.siteContact = this.formData.serviceSite.DefaultSiteContact
        this.formData.siteContactPhone = this.formData.serviceSite.DefaultSitePhone
        this.formData.serviceCenter = this.formData.serviceSite.DefaultServiceCenter
      } else {
        this.siteList.forEach((val) => {
          if (val.SMServiceSiteID == this.formData.serviceSite) {
            this.formData.siteContact = val.DefaultSiteContact
            this.formData.siteContactPhone = val.DefaultSitePhone
            this.formData.serviceCenter = val.DefaultServiceCenter
            this.formData.customer = this.formData.customer == null ? val.SMCustomerID : this.formData.customer
          }
        })
      }
    }
    if (this.formData.customer == null) {
      this.siteList.forEach((val) => {
        if (val.SMServiceSiteID == this.formData.serviceSite.SMServiceSiteID) {
          this.formData.customer = val.SMCustomerID
        }
      })
      this.siteList = (this.siteList.filter(site => site.SMCustomerID == this.formData.customer))
    }
  }

   getCenters() {
     this.smService.getServiceCenters(this.formData.technician.SMCo).then((response: any) => {
      this.centerList = response
      this.centerList.forEach((val) => {
        var temp = new DOMParser()
        var temp2 = temp.parseFromString(val.Divisions, "text/xml")
        var temp3: any = this.utilityService.xmlToJson(temp2)
        var temp4 = []
        $.each(temp3?.DivisionList?.Division, function (key2, val2) {
          if (val2.attributes != null)
            temp4.push({ Description: val2.attributes.Description, Division: val2.attributes.Division })
          else
            temp4.push({ Description: val2.Description, Division: val2.Division })
        })
        this.divisionList[val.ServiceCenter] = temp4
      })
    })
  }

  serviceCenterChanged() {
    this.formData.division = null
  }

  createNewWorkOrderClicked() {
    this.alert = null
    if (this.formData.description != null && this.formData.description != '' && this.formData.technician != null && this.formData.customer != null) {
      this.utilityService.openModal()
       const data = {
           sMCo: this.currentSMCo, sMWorkOrderID: -1, sMCustomerID: this.formData.customer, sMServiceSiteID: this.formData.serviceSite?.SMServiceSiteID,
          workOrderDescription: this.formData.description, requestedBy: this.formData.requestedBy, requestedByPhone: this.formData.requestedByPhone, contactName: this.formData.siteContact,
          contactPhone: this.formData.siteContactPhone, leadTechnician: this.formData.technician.Technician, serviceCenter: this.formData.serviceCenter, sMWorkOrderNotes: this.formData.notes,
         includeUnscheduled: this.formData.isUnscheduled, workOrder: this.formData.workOrder, sMCallType: this.formData.callType, division: this.formData.division, sMTripID: null
       }
      this.smService.workOrderInsertUpdate(data).then((response: any) => {
        if (response.success)
          this.ngbActiveModal.close(response)
        else {
          this.alert = response.error
          this.utilityService.closeModal();
        }
      })
    }
  }

  cancelClicked() {
    this.utilityService.closeModal();
    this.ngbActiveModal.dismiss();
  }
}
